module.exports = __webpack_public_path__ + "3ac7883974e2fedd8165a7ced834e2c1.svg";